"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Ignores if the given function throws an error or not and returns the value.
 * @example
 * import { ignoreRejectionFor } from 'promise-frites';
 *
 * const logToRemote = () => Promise.reject('Api Error');
 * Promise.resolve()
 *   .then(ignoreRejectionFor(logToRemote))
 *   .then((value) => assertThat(value, equalTo('Api Error')));
 */
var ignoreRejectionFor = exports.ignoreRejectionFor = function ignoreRejectionFor(fn) {
  return function (arg) {
    return Promise.resolve().then(function () {
      return fn(arg);
    }).catch(function (result) {
      return result;
    });
  };
};